<template>
  <div v-if="notification.type === NotificationType.CLAIM_CREATE">
    {{ `New claim created for ${content.storeName} order ${content.orderNumber}` }}
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_STATUS_CHANGE">
    <span>{{ `Claim for ${content.storeName} order ${content.orderNumber} moved to ` }}</span>
    <span class="font-semibold">{{ `${claimState}` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_RESOLUTION">
    <span>{{ `Claim for ${content.storeName} order ${content.orderNumber} was ${resolutionType} by ` }}</span>
    <span class="font-semibold">{{ `${content.userName}` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_MESSAGES">
    <span>{{ `New message from customer ` }}</span>
    <span class="font-semibold">{{ `${content.authorName}` }}</span>
    <span>{{ ` for claim on order ${content.orderNumber}` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.INTERNAL_NOTES">
    <span> {{ `New note added by ` }}</span>
    <span class="font-semibold">{{ `${content.noteUserName}` }}</span>
    <span> {{ ` for ${content.storeName} claim on order ${content.orderNumber}` }} </span>
  </div>
  <div v-else-if="notification.type === NotificationType.INTERNAL_NOTES_MENTION">
    <span class="font-semibold">{{ `${content.noteUserName}` }}</span>
    <span> {{ ` mentioned you in a note for ${content.storeName} on order ${content.orderNumber}` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_REVIEWS">
    <span class="font-semibold">{{ `${content.authorName}` }}</span>
    <span>{{ ` left a ${content.rating} star review for claim on order ${content.orderNumber}` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.SOP_CREATE">
    {{ `New SOP ${content.sopTitle} for ${content.storeName} has been created` }}
  </div>
  <div v-else-if="notification.type === NotificationType.SOP_UPDATE">
    {{ `SOP ${content.sopTitle} for ${content.storeName} has been updated` }}
  </div>
  <div v-else-if="notification.type === NotificationType.MACRO_CREATE">
    {{ `New macro ${content.macroTitle} for ${content.storeName} has been created` }}
  </div>
  <div v-else-if="notification.type === NotificationType.MACRO_UPDATE">
    {{ `Macro ${content.macroTitle} for ${content.storeName} has been updated` }}
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_TAKEOVER_STALE">
    <span>{{ `You took over the claim on order ${content.orderNumber} ` }}</span>
    <span class="font-semibold">{{ `${takeoverIdleLabel(content)} ago` }}</span>
    <span>{{ ` and it hasn't been actioned` }}</span>
  </div>
  <div v-else-if="notification.type === NotificationType.CLAIM_TAKEOVER_RETURNED">
    <span class="font-semibold">{{ `AI resumed` }}</span>
    <span>{{ ` the claim on order ${content.orderNumber} after ${takeoverIdleLabel(content)} without action` }}</span>
  </div>
</template>
<script setup lang="ts">
import { NotificationType } from '@constants';
import { ResolutionTypeToText, StateToText, takeoverIdleLabel } from '@helpers';
import type { Dispatch } from '@monolog/shared/types';
import capitalize from 'lodash/capitalize';

const props = defineProps<{ notification: Dispatch.Notification }>();

const formatLabel = (text: string) => {
  return text
    .split('_')
    .map(word => capitalize(word))
    .join(' ');
};

const content = computed(() => {
  return props.notification.content as Record<string, any>;
});

const claimState = computed(() => {
  const claimState = content.value.claimState?.toUpperCase() ?? '';

  return StateToText[claimState] || formatLabel(claimState);
});

const resolutionType = computed(() => {
  const resolutionType: string = content.value.resolutionType?.toUpperCase() ?? '';

  return ResolutionTypeToText[resolutionType] || formatLabel(resolutionType);
});
</script>
